<template>
  <div v-if="visible" class="happy-hour-bar">
    <span class="happy-hour-bar__text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "HappyHourBar",

  computed: {
    locale() {
      // reactive current language (vuex-i18n stores it in the i18n module)
      const i18n = this.$store.state.i18n;
      return (i18n && i18n.locale) || "sr";
    },
    happyHour() {
      return this.$store.state.settings.happyHour || {};
    },
    text() {
      const t = this.happyHour.text || {};
      return t[this.locale] || t.sr || t.en || t.ru || "";
    },
    visible() {
      return !!this.happyHour.enabled && !!this.text;
    }
  }
};
</script>

<style scoped>
.happy-hour-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  background: #000;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
}
.happy-hour-bar__text {
  font-weight: bold;
  font-size: 15px;
  line-height: 1.3;
  letter-spacing: 0.03em;
}
@media screen and (max-width: 1024px) {
  .happy-hour-bar__text {
    font-size: 13px;
  }
}
</style>
